import React from 'react';
import { SvgIcon } from '@mui/material';
import { shape } from 'prop-types';

const LoadingRounded = props => (
  <SvgIcon classes={props.classes} viewBox="-2 -2 24 24">
    <path d="M11.133 15.734a1.133 1.133 0 10-2.267 0v3.133a1.133 1.133 0 002.267 0V15.734zM11.133 1.108a1.134 1.134 0 00-2.266 0v3.16a1.133 1.133 0 102.266 0V1.108zM17.07 15.467l-2.213-2.213h-.002a1.132 1.132 0 10-1.602 1.602l2.215 2.215a1.134 1.134 0 001.602-1.602v-.002zM2.91 4.514l2.234 2.233v.001a1.133 1.133 0 101.602-1.603L4.532 2.93l-.001-.002-.002-.002-.017-.017v.001A1.133 1.133 0 002.91 4.513v.001zM18.866 8.867H15.734a1.133 1.133 0 100 2.267h3.132a1.134 1.134 0 100-2.267zM4.266 11.134h.001a1.134 1.134 0 000-2.267H1.108a1.133 1.133 0 000 2.266v.001h3.158zM14.855 6.748l2.216-2.215A1.134 1.134 0 0015.47 2.93l-.002.001-2.213 2.213v.001a1.134 1.134 0 001.602 1.602zM5.145 13.253L2.93 15.467l-.002.002-.001.001-.018.018h.001a1.134 1.134 0 001.602 1.602l2.234-2.234a1.132 1.132 0 000-1.602 1.131 1.131 0 00-1.602 0z" />
  </SvgIcon>
);

LoadingRounded.propTypes = {
  classes: shape({}),
};

LoadingRounded.defaultProps = {
  classes: {},
};

export default LoadingRounded;
